import './AttentionTile.css';

export type AttentionSeverity = 'neutral' | 'good' | 'warning' | 'serious' | 'critical';

const SEVERITY_WORD: Record<AttentionSeverity, string> = {
  neutral: 'Note',
  good: 'Good',
  warning: 'Warning',
  serious: 'Serious',
  critical: 'Critical',
};

export interface AttentionTileProps {
  severity: AttentionSeverity;
  /** A short glyph/character, e.g. "$" — a domain icon, not a severity
   *  signal on its own. */
  icon: string;
  title: string;
  sub?: string;
  /** Overrides the corner word. Defaults to the severity's own name — the
   *  accessibility contract this primitive exists for ("never colour
   *  alone") is that word, not the stripe. */
  word?: string;
  onClick?: () => void;
}

// Trust-posture primitive (5) — severity is always stripe + icon + WORD
// together, never colour alone. Five locked levels (Huan 2026-07-10);
// neutral exists so "good" stays meaningful.
export function AttentionTile({ severity, icon, title, sub, word, onClick }: AttentionTileProps) {
  const interactive = onClick
    ? {
        role: 'button' as const,
        tabIndex: 0,
        onClick,
        onKeyDown: (e: KeyboardEvent) => (e.key === 'Enter' || e.key === ' ') && onClick(),
      }
    : {};
  return (
    <div class={`vw-attention-tile vw-attention-tile--${severity}`} {...interactive}>
      <div class="vw-attention-tile__icon">{icon}</div>
      <div class="vw-attention-tile__body">
        <div class="vw-attention-tile__title">{title}</div>
        {sub ? <div class="vw-attention-tile__sub">{sub}</div> : null}
      </div>
      <div class="vw-attention-tile__word">{word ?? SEVERITY_WORD[severity]}</div>
    </div>
  );
}
